import { MutableRefObject } from 'react';
import { Location } from 'react-router-dom';

/**
 * Determine the IDP name from the Cognito username.
 *
 * @param username - Cognito username
 * @returns - IDP name
 */
export const determineIdpFromCognitoUsername = (username: string): string => {
  let sIdp = '';
  switch (true) {
    case username.includes('Google'):
      sIdp = 'Google';
      break;
    case username.includes('Amazon'):
      sIdp = 'Amazon';
      break;
    case username.includes('Apple'):
      sIdp = 'Apple';
      break;
    default:
      sIdp = 'Other';
      break;
  }
  return sIdp;
};

export const isFirstTimeUser = (attributes: Record<string, string>): boolean =>
  !attributes['custom:isFtu'] || attributes['custom:isFtu'] === '1';

export const isMagicLink = (location: Location): boolean => {
  if (
    !location ||
    !location.search ||
    location.pathname !== '/sign-up/validation/magic-link'
  ) {
    return false;
  }
  const searchParams = new URLSearchParams(location.search);
  return searchParams.has('magic');
};

export const getRedirectPath = (
  incomingRedirect: string | null,
  isFtu: boolean // is first-time user
): string => {
  let redirect = incomingRedirect || '';
  // Provide a default redirect path if none is specified
  if (!redirect) {
    redirect = isFtu ? '/sign-up' : '/main';
  }

  // First-time users are only allowed to go to the sign-up page or complete the sign-up process via a magic link.
  if (isFtu && !redirect.includes('magic-link') && redirect !== '/sign-up') {
    console.warn(
      'First-time users can only be redirected to the sign-up page or complete the sign-up process via a magic link.'
    );
    redirect = '/sign-up';
  }
  return redirect;
};

export const userAuthStatusMap = {
  notSignedIn: 'not-signed-in',
  signedInUnmatched: 'signed-in-unmatched',
  signedInMatched: 'signed-in-matched',
  loading: 'loading',
};

/**
 * Clears a timeout and resets the ref to null
 *
 * @param timeoutRef - React useRef object containing a timeout ID
 */
export const clearTimeoutRef = (
  timeoutRef: MutableRefObject<NodeJS.Timeout | null>
): void => {
  if (timeoutRef.current) {
    clearTimeout(timeoutRef.current);
    // eslint-disable-next-line no-param-reassign
    timeoutRef.current = null;
  }
};

export default {};
